/** BackgroundImage: Stretch background safely without page scroll */
import type { FC, ReactNode } from "react";
import backgroundImageEmployee from "./assets/images/background-blur-employee.svg";
import backgroundImageAdmin from "./assets/images/background-blur.svg";

type BackgroundImageProps = {
  children: ReactNode;
  platform: "admin" | "employee";
};

export const BackgroundImage: FC<BackgroundImageProps> = ({
  children,
  platform,
}) => {
  return (
    <div className="relative min-h-screen">
      <div
        className="fixed -inset-[15px] -z-10"
        style={{
          backgroundImage: `url(${platform === "employee" ? backgroundImageEmployee : backgroundImageAdmin})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      />
      <div className="relative flex min-h-screen flex-col justify-center gap-8 max-sm:p-6">
        {children}
      </div>
    </div>
  );
};
